/**
 * `/genres/:slug` and `/tags/:slug` — the two vocabulary listings.
 *
 * An aggregate array, so the file takes the PLURAL name. The two patterns are
 * disjoint literals in their first segment, so no matcher ordering decides
 * between them or against anything else in the table.
 *
 * The param is the **slug**, matching the public site's own URL contract for
 * these two surfaces — a reader who has an address from either host can paste it
 * into the other. Slugs here are Arabic prose, which is fine on a static SPA
 * host: the history fallback serves `index.html` for any path, and the segment
 * never reaches a backend. The listing sends it as a query VALUE, which is where
 * `backend-search` resolves it against its taxonomy mirror.
 *
 * `BrowsePage` is one component under two facets rather than two components:
 * the page is the same grid, the same empty state and the same filter panel,
 * differing only in which facet the route fixes and where the term's name is
 * read from.
 */
import type { RouteObject } from 'react-router-dom';

export const genreRoute: RouteObject = {
  path: 'genres/:slug',
  lazy: async () => {
    const { BrowsePage } = await import('./BrowsePage');
    return { Component: () => <BrowsePage facet="genre" /> };
  },
};

export const tagRoute: RouteObject = {
  path: 'tags/:slug',
  lazy: async () => {
    const { BrowsePage } = await import('./BrowsePage');
    return { Component: () => <BrowsePage facet="tag" /> };
  },
};

export const browseRoutes: RouteObject[] = [genreRoute, tagRoute];
